(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  function getAnnouncementBarHeight() {
    const announcementBar = document.querySelector('.announcement.block');
    return announcementBar ? announcementBar.getBoundingClientRect().height : 0;
  }

  function getHeaderHeight() {
    const header = document.querySelector('.cc-header');
    return header ? header.getBoundingClientRect().height : 0;
  }

  function moveDropdownToBody(content) {
    if (window.innerWidth >= 768 && !content.parentElement.matches('body')) {
      document.body.appendChild(content);
    }
  }

  function positionDropdown(button, content) {
    if (window.innerWidth >= 768) {
      const rect = button.getBoundingClientRect();
      moveDropdownToBody(content);
      
      content.style.position = 'fixed';
      content.style.top = rect.bottom + 'px';
      content.style.left = rect.left + 'px';
      content.style.width = rect.width + 'px';
      content.style.zIndex = '1000';
      content.style.maxHeight = `calc(100vh - ${rect.bottom + 20}px)`;
      content.style.overflowY = 'auto';
    }
  }

  function showDropdown(button, content) {
    hideFastrakCollapsibleDropdowns(content);
    
    // Return content to its original parent if on mobile
    if (window.innerWidth < 768 && content.parentElement === document.body) {
      button.parentElement.appendChild(content);
    }
    
    content.style.display = 'block';
    if (window.innerWidth >= 768) {
      positionDropdown(button, content);
    }
    requestAnimationFrame(() => {
      content.classList.add('visible');
    });
  }

  function hideDropdown(content) {
    content.classList.remove('visible');
    const transitionEndHandler = () => {
      if (!content.classList.contains('visible')) {
        content.style.display = 'none';
        // Return content to its original parent if on mobile
        if (window.innerWidth < 768 && content.parentElement === document.body) {
          const button = document.querySelector(`[data-dropdown-content="${content.id}"]`);
          if (button) {
            button.parentElement.appendChild(content);
          }
        }
      }
    };

    if (window.innerWidth >= 768) {
      content.addEventListener('transitionend', transitionEndHandler, { once: true });
    } else {
      setTimeout(transitionEndHandler, 300);
    }
  }

  function hideFastrakCollapsibleDropdowns(exceptContent = null) {
    document.querySelectorAll('.fastrak-collapsible-content').forEach(content => {
      if (content !== exceptContent && content.style.display === 'block') {
        hideDropdown(content);
      }
    });
  }

  window.hideFastrakCollapsibleDropdowns = hideFastrakCollapsibleDropdowns;

  document.querySelectorAll('.fastrak-collapsible-header').forEach((button, index) => {
    const content = button.nextElementSibling;
    if (content) {
      // Add unique identifier to link content and button
      content.id = `dropdown-content-${index}`;
      button.setAttribute('data-dropdown-content', `dropdown-content-${index}`);
      
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (content) {
          if (content.style.display === 'block') {
            hideDropdown(content);
          } else {
            showDropdown(button, content);
          }
        }
      });
    }
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('.fastrak-collapsible-header, .fastrak-collapsible-content')) {
      hideFastrakCollapsibleDropdowns();
    }
  });

  // Handle window resize to ensure proper dropdown positioning and parent
  window.addEventListener('resize', () => {
    const isMobile = window.innerWidth < 768;
    document.querySelectorAll('.fastrak-collapsible-content').forEach(content => {
      if (content.style.display === 'block') {
        const button = document.querySelector(`[data-dropdown-content="${content.id}"]`);
        if (button) {
          if (isMobile && content.parentElement === document.body) {
            button.parentElement.appendChild(content);
          } else if (!isMobile && content.parentElement !== document.body) {
            document.body.appendChild(content);
            positionDropdown(button, content);
          }
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["predictive-search"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  function getAnnouncementBarHeight() {
    const announcementBar = document.querySelector('.announcement.block');
    return announcementBar ? announcementBar.getBoundingClientRect().height : 0;
  }

  function getHeaderHeight() {
    const header = document.querySelector('.cc-header');
    return header ? header.getBoundingClientRect().height : 0;
  }

  function moveDropdownToBody(content) {
    if (window.innerWidth >= 768 && !content.parentElement.matches('body')) {
      document.body.appendChild(content);
    }
  }

  function positionDropdown(button, content) {
    if (window.innerWidth >= 768) {
      const rect = button.getBoundingClientRect();
      moveDropdownToBody(content);
      
      content.style.position = 'fixed';
      content.style.top = rect.bottom + 'px';
      content.style.left = rect.left + 'px';
      content.style.width = rect.width + 'px';
      content.style.zIndex = '1000';
      content.style.maxHeight = `calc(100vh - ${rect.bottom + 20}px)`;
      content.style.overflowY = 'auto';
    }
  }

  function showDropdown(button, content) {
    document.querySelectorAll('.fastrak-collapsible-content').forEach(otherContent => {
      if (otherContent !== content) {
        hideDropdown(otherContent);
      }
    });
    
    // Return content to its original parent if on mobile
    if (window.innerWidth < 768 && content.parentElement === document.body) {
      button.parentElement.appendChild(content);
    }
    
    content.style.display = 'block';
    if (window.innerWidth >= 768) {
      positionDropdown(button, content);
    }
    requestAnimationFrame(() => {
      content.classList.add('visible');
    });
  }

  function hideDropdown(content) {
    content.classList.remove('visible');
    const transitionEndHandler = () => {
      if (!content.classList.contains('visible')) {
        content.style.display = 'none';
        // Return content to its original parent if on mobile
        if (window.innerWidth < 768 && content.parentElement === document.body) {
          const button = document.querySelector(`[data-dropdown-content="${content.id}"]`);
          if (button) {
            button.parentElement.appendChild(content);
          }
        }
      }
    };

    if (window.innerWidth >= 768) {
      content.addEventListener('transitionend', transitionEndHandler, { once: true });
    } else {
      setTimeout(transitionEndHandler, 300);
    }
  }

  document.querySelectorAll('.fastrak-collapsible-header').forEach((button, index) => {
    const content = button.nextElementSibling;
    if (content) {
      // Add unique identifier to link content and button
      content.id = `dropdown-content-${index}`;
      button.setAttribute('data-dropdown-content', `dropdown-content-${index}`);
      
      let isHovering = false;
      
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (content) {
          if (content.style.display === 'block') {
            hideDropdown(content);
          } else {
            showDropdown(button, content);
          }
        }
      });

      if (content) {
        button.addEventListener('mouseenter', () => {
          if (window.innerWidth >= 768) {
            isHovering = true;
            showDropdown(button, content);
          }
        });

        button.addEventListener('mouseleave', (e) => {
          if (window.innerWidth >= 768) {
            isHovering = false;
            setTimeout(() => {
              if (!isHovering && !content.matches(':hover')) {
                hideDropdown(content);
              }
            }, 100);
          }
        });

        content.addEventListener('mouseenter', () => {
          if (window.innerWidth >= 768) {
            isHovering = true;
          }
        });

        content.addEventListener('mouseleave', () => {
          if (window.innerWidth >= 768) {
            isHovering = false;
            setTimeout(() => {
              if (!isHovering && !button.matches(':hover')) {
                hideDropdown(content);
              }
            }, 100);
          }
        });
      }
    }
  });

  // Handle window resize to ensure proper dropdown positioning and parent
  window.addEventListener('resize', () => {
    const isMobile = window.innerWidth < 768;
    document.querySelectorAll('.fastrak-collapsible-content').forEach(content => {
      if (content.style.display === 'block') {
        const button = document.querySelector(`[data-dropdown-content="${content.id}"]`);
        if (button) {
          if (isMobile && content.parentElement === document.body) {
            button.parentElement.appendChild(content);
          } else if (!isMobile && content.parentElement !== document.body) {
            document.body.appendChild(content);
            positionDropdown(button, content);
          }
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
